import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService, ConfigService, PageService, SettingsService } from '@gallaghercp/core-frontend';
import { Subscription } from 'rxjs';
import { ClientService } from '../../services/client.service';

@Component({
    selector: 'core-oops',
    templateUrl: './oops.component.html',
    standalone: false,
})
export class OopsComponent implements OnInit, OnDestroy {
    protected auth = inject(AuthService);
    protected api = inject(HttpClient);
    protected pages = inject(PageService);
    client = inject(ClientService);
    protected settings = inject(SettingsService);
    protected router = inject(Router);
    protected titleService = inject(Title);
    protected breakpoint = inject(BreakpointObserver);
    protected config = inject(ConfigService);

    pageNotFound?: string | undefined;

    copyright: string = this.config.get('copyright') || '';
    appName: string = this.config.get('appName') || '';

    loading = false;
    subscriptions: Subscription[] = [];

    ngOnInit() {
        this.titleService.setTitle('Page not found - ' + this.appName);

        if (!this.pages.pageNotFound) {
            this.router.navigate(['/']);
        } else {
            this.pageNotFound = this.pages.pageNotFound;
        }
    }

    getSiteName() {
        return this.client.getSiteName();
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
}
